import script from "./GoalNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoalNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./GoalNavigation.vue?vue&type=style&index=0&id=3bb1efb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bb1efb4"]])

export default __exports__